module.exports = __webpack_public_path__ + "assets/img/inviteImg.3697b0ba.jpg";